/* eslint-disable import/max-dependencies */
// @flow
import {
  call,
  put,
  debounce,
  select,
} from "redux-saga/effects";
import type { Saga } from "redux-saga";
import type { Response } from "@fas/ui-framework/lib/services/request";
import { addNotification } from "@fas/ui-framework/lib/redux/actions/notifications";
import {
  getTablePage,
  getTablePageSize,
  getTableFilters,
} from "@fas/ui-framework/lib/redux/selectors/table";
import {
  setTableData,
  changeTableItemsTotalAmount,
} from "@fas/ui-framework/lib/redux/actions/table";
import { setLoading } from "@fas/ui-framework/lib/redux/actions/loading";
import type { Filters } from "@fas/ui-framework/lib/redux/reducers/table";
import {
  GET_IPP_LIST_SAGA,
  IPP_LIST_TABLE,
} from "../../helpers/constants";
import IPPApi from "../../services/IPPApi";
import type { IPP } from "../../components/IppList";

export function* makeFetch(): Saga<void> {
  yield put(setLoading(IPP_LIST_TABLE, true));

  const page: number = yield select(getTablePage, IPP_LIST_TABLE);
  const limit: number = yield select(getTablePageSize, IPP_LIST_TABLE);
  const filters: Filters = yield select(getTableFilters, IPP_LIST_TABLE);

  try {
    const { data: response }: Response<{
      data: IPP[],
      totalCount: number
      // $FlowFixMe
    }> = yield call(
      IPPApi.getIPPList,
      page,
      limit,
      filters
    );

    yield put(setTableData(IPP_LIST_TABLE, response.data));
    yield put(changeTableItemsTotalAmount(IPP_LIST_TABLE, response.totalCount));
  }
  catch (err) {
    yield put(addNotification({ message: err.errorMessage, severity: "error" }));
    // eslint-disable-next-line
    console.error(err);
  }
  finally {
    yield put(setLoading(IPP_LIST_TABLE, false));
  }
}

export default function* watchFetchIPPListSaga(): Saga<void> {
  yield debounce(1000, GET_IPP_LIST_SAGA, (makeFetch: Function));
}
